export const createAudioFromBlob = (source) => {
    let URL = window.URL || window.webkitURL;

    try {
        return URL.createObjectURL(source)
    } catch(error) {
        console.error(error);
    }
}